import styled from "styled-components";

import { TableRow } from "../../../constants/Styles";

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const LeftSection = styled.td`
  width: 167px;
  height: 100%;
  padding-left: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Title = styled.div`
  display: flex;
  align-items: center;
`;

const RightSection = styled.td`
  display: flex;
  width: 100%;

  > img {
    padding: 1rem;
    margin: 1rem auto;
    max-width: 100%;
    max-height: 60vh;
    cursor: pointer;
  }
`;

const Table = styled.table`
  width: 100%;
`;

const PreviewTableRow = styled(TableRow)`
  display: flex;
  align-items: center;
`;

export { Container, Title, LeftSection, RightSection, Table, PreviewTableRow };
